// Modern line icons for the services ("Full-stack capabilities") section.
// 24px grid, rounded strokes, brand violet → cyan gradient.

const gradientStops = (
  <>
    <stop offset="0%" stopColor="#8F6CFE" />
    <stop offset="100%" stopColor="#22CAF4" />
  </>
);

interface IconProps {
  gradientId: string;
  children: React.ReactNode;
}

const IconBase: React.FC<IconProps> = ({ gradientId, children }) => (
  <svg
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
    stroke={`url(#${gradientId})`}
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
        {gradientStops}
      </linearGradient>
    </defs>
    {children}
  </svg>
);

/** AI & Software Development — sparkles */
export const SparklesIcon: React.FC = () => (
  <IconBase gradientId="svc-grad-ai">
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    <path d="M20 3v4" />
    <path d="M22 5h-4" />
    <path d="M4 17v2" />
    <path d="M5 18H3" />
  </IconBase>
);

/** Web & Application Development — code brackets in a window */
export const CodeWindowIcon: React.FC = () => (
  <IconBase gradientId="svc-grad-web">
    <rect x="2" y="4" width="20" height="16" rx="2.5" />
    <path d="M2 8.5h20" />
    <path d="m9.5 12-2.25 2.25L9.5 16.5" />
    <path d="m14.5 12 2.25 2.25-2.25 2.25" />
  </IconBase>
);

/** Smart Contract Development — shield with check */
export const ShieldCheckIcon: React.FC = () => (
  <IconBase gradientId="svc-grad-chain">
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1 1 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    <path d="m9 12 2 2 4-4" />
  </IconBase>
);

/** Technology Consulting — compass */
export const CompassIcon: React.FC = () => (
  <IconBase gradientId="svc-grad-consult">
    <circle cx="12" cy="12" r="10" />
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
  </IconBase>
);
